<template>
  <div class="dialog-fullscreen" @click.stop>
    <div class="dialog-container">
      <div class="dialog-message">
        {{ message }}
      </div>
      <div class="dialog-buttons">
        <a
          v-for="b in buttons"
          :key="b.message"
          @click="closeDialog(b)"
          class="dialog-button"
          v-ripple
        >
          {{ b.message }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogConfirm',
  data() {
    return {
      //message: 'Watch the following advert to see the hint.',
      //buttons: [{ message: 'Ok' }, { message: 'No thanks' }],
    }
  },
  computed: {
    message() {
      return this.$store.getters.confirmDialogVals.message
    },
    buttons() {
      return this.$store.getters.confirmDialogVals.buttons
    },
  },
  methods: {
    closeDialog(b) {
      if (b.callBack) {
        b.callBack()
      }
      this.$store.dispatch('clear_confirmation_dialog')
    },
  },
}
</script>

<style scoped>
.dialog-fullscreen {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  transition: background-color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  /*z-index: 1000;*/
}

.dialog-container {
  width: calc(100% - 2rem);
  max-width: 30rem;
  /*transform: translate(calc(50vw - 50%), calc(50vh - 50%));*/
  background-color: #003745;
  color: #cdf4dd;
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
  padding: 2rem 2rem 1rem 2rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.3s, transform 0.3s;
  /*border: 1px solid #cdf4dd;*/
}

.dialog-message {
  text-align: center;
  margin-bottom: 2rem;
}

.dialog-buttons {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -1rem;
}

.dialog-button {
  display: block;
  padding: 1em;
  text-align: center;
  border: 1px solid #cdf4dd;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.5s ease;
  margin-bottom: 1rem;
  margin-left: 1rem;
  flex: 1 1 6rem;
}

@media (hover: hover) {
  .dialog-button:hover {
    background-color: rgba(204, 244, 221, 0.1);
  }
}
</style>
